import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshUser = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me", { timeout: 20000 });
      setUser(data);
      return data;
    } catch {
      try {
        const { data } = await api.post("/auth/refresh", null, { timeout: 20000 });
        setUser(data);
        return data;
      } catch {
        setUser(false);
        return false;
      }
    }
  }, []);

  useEffect(() => {
    refreshUser();
  }, [refreshUser]);

  const login = useCallback(async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password }, { timeout: 20000 });
    setUser(data);
    return data;
  }, []);
  const register = useCallback(async (email, password, name) => {
    const { data } = await api.post("/auth/register", { email, password, name }, { timeout: 20000 });
    setUser(data);
    return data;
  }, []);
  const logout = useCallback(async () => {
    await api.post("/auth/logout").catch(() => {});
    setUser(false);
  }, []);

  const value = useMemo(() => ({ user, setUser, login, register, logout, refreshUser }), [user, login, register, logout, refreshUser]);
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
